/* eslint-disable no-undef */
import { useState } from 'react';
import { setItem } from '../services/storage';

type StorageReturn<T> = [value: T, updateValue: (newValue: T) => void];

/*
  IMPORTANT
  When using this hook, an initial value is not retrieved from a cookie
  The initial value must retrieved from a serverside function and passed to the UI component
 */

function useStorage<T>(key: string, initialState: T): StorageReturn<T> {
  const [value, setValue] = useState<T>(initialState);

  const updateValue = (newValue: T) => {
    setItem(key, newValue);
    setValue(newValue);
  };

  return [value, updateValue];
}

export default useStorage;
